(function () {
  function money(cents) {
    return window.Axiom.formatMoney(cents);
  }

  function formatSaveLabel(compare, price, template, mode) {
    var savings = compare - price;
    var replacement = money(savings);
    if (mode === 'percent' && compare > 0) {
      replacement = String(Math.round((savings * 100) / compare)) + '%';
    }
    return String(template || 'Save [amount]')
      .replace('[amount]', replacement)
      .replace('[percent]', replacement);
  }

  function decodeHtmlString(value) {
    if (typeof value !== 'string' || value.indexOf('&') === -1) return value;
    var textarea = document.createElement('textarea');
    textarea.innerHTML = value;
    return textarea.value;
  }

  function decodeConfigStrings(config) {
    Object.keys(config || {}).forEach(function (key) {
      config[key] = decodeHtmlString(config[key]);
    });
    return config || {};
  }

  function productString(key) {
    return ((window.Axiom && window.Axiom.productStrings && window.Axiom.productStrings[key]) || '').toString();
  }

  function cartString(key) {
    return ((window.Axiom && window.Axiom.cartStrings && window.Axiom.cartStrings[key]) || '').toString();
  }

  function setMotionButtonText(target, text) {
    if (!target) return;
    if (window.Axiom && typeof window.Axiom.setMotionLabel === 'function') {
      if (window.Axiom.setMotionLabel(target, text, 'button')) return;
    }
    target.textContent = text;
  }

  function sellingPlanIdFromForm(form) {
    var input = form && (form.querySelector('[data-selling-plan-input]') || form.querySelector('[name="selling_plan"]'));
    return input ? String(input.value || '').trim() : '';
  }

  function initFeaturedProduct(root) {
    if (!root || root.dataset.featuredProductInitialized === 'true') return;

    var productJsonEl = root.querySelector('[data-featured-product-json]');
    var variantStateEl = root.querySelector('[data-featured-product-variant-state]');
    var configEl = root.querySelector('[data-featured-product-config]');
    if (!productJsonEl || !variantStateEl || !configEl) return;

    var product = null;
    var variantState = {};
    var config = {};
    try { product = JSON.parse(productJsonEl.textContent); } catch (error) { return; }
    try { variantState = JSON.parse(variantStateEl.textContent) || {}; } catch (error) {}
    try { config = decodeConfigStrings(JSON.parse(configEl.textContent) || {}); } catch (error) {}
    var highVariantState = window.AxiomHighVariantPicker && window.AxiomHighVariantPicker.read(root);
    var highVariantProduct = window.AxiomHighVariantPicker && window.AxiomHighVariantPicker.isHighVariant(highVariantState);
    var selectedHighVariant = highVariantProduct ? highVariantState.variant : null;
    var highVariantRequest = null;
    if (highVariantProduct && selectedHighVariant && highVariantState.variantState) {
      variantState[String(selectedHighVariant.id)] = highVariantState.variantState;
    }

    root.dataset.featuredProductInitialized = 'true';
    if (window.AxiomInventoryMessage) {
      window.AxiomInventoryMessage.initialize(root);
    }

    var form = root.querySelector('[data-featured-product-form]');
    var variantIdInput = root.querySelector('[data-featured-variant-id]');
    var atcBtn = root.querySelector('[data-featured-atc]');
    var dynamicCheckoutRoot = root.querySelector('[data-featured-dynamic-checkout]');

    function setVariantLoading(isLoading) {
      if (atcBtn) atcBtn.classList.toggle('is-variant-loading', Boolean(isLoading));
      if (dynamicCheckoutRoot) dynamicCheckoutRoot.classList.toggle('is-variant-loading', Boolean(isLoading));
    }
    var cartStatus = root.querySelector('[data-featured-cart-status]');
    var atcLabel = atcBtn ? atcBtn.querySelector('.atc-label') : null;
    var qtyInput = root.querySelector('[data-featured-qty-input]');

    function setCartStatus(message) {
      if (!cartStatus) return;
      cartStatus.textContent = message || '';
      cartStatus.hidden = !message;
    }
    var qtyVal = root.querySelector('[data-featured-qty-val]');
    var qtyMinusBtn = root.querySelector('[data-featured-qty-minus]');
    var qtyPlusBtn = root.querySelector('[data-featured-qty-plus]');
    var pendingVariantId = null;
    var pendingSource = '';
    var addedResetTimer = null;
    var sourceToken = root.dataset.featuredProductSource || '';
    var mediaGallery = root.querySelector('[data-media-gallery]');
    var mediaMainWrap = mediaGallery ? mediaGallery.querySelector('[data-zoom-wrap]') : null;
    var galleryController = null;
    var cleanups = [];

    function on(target, eventName, handler, options) {
      if (!target || typeof target.addEventListener !== 'function') return;
      target.addEventListener(eventName, handler, options);
      cleanups.push(function () {
        target.removeEventListener(eventName, handler, options);
      });
    }

    function getFormSubmitter(event) {
      if (event && event.submitter) return event.submitter;
      return document.activeElement && document.activeElement.closest
        ? document.activeElement.closest('button, input[type="submit"]')
        : null;
    }

    function pauseProductMedia() {
      if (window.AxiomProductMedia) {
        window.AxiomProductMedia.pauseAll(mediaGallery || root);
      }
    }

    if (window.AxiomProductGalleryController && mediaGallery) {
      galleryController = window.AxiomProductGalleryController.create(mediaGallery, {
        mediaSelector: '[data-media-item]',
        thumbSelector: '[data-thumb]',
        pauseMedia: pauseProductMedia,
        isControlTarget: function (target) {
          return window.AxiomProductMedia && window.AxiomProductMedia.isControlTarget
            ? window.AxiomProductMedia.isControlTarget(target)
            : false;
        },
        onActiveChange: function (item) {
          if (mediaMainWrap && item) mediaMainWrap.dataset.currentMediaType = item.type;
          if (!window.AxiomProductMedia) return;
          window.AxiomProductMedia.syncXrButton(mediaGallery, item && item.id);
          window.AxiomProductMedia.playAutoplay(item && item.element);
        }
      });
    }

    function setActiveMedia(index, options) {
      if (!galleryController) return;
      galleryController.setMedia(index, options || {});
    }

    function setActiveMediaById(mediaId, options) {
      if (!galleryController || !mediaId) return;
      options = options || {};
      var nextIndex = galleryController.mediaIndexForId(mediaId);
      if (nextIndex >= 0) {
        galleryController.setMedia(nextIndex, {
          scrollMedia: options.scrollMedia === true,
          scrollThumb: options.scrollThumb === true,
          source: options.source || 'sync'
        });
      }
    }

    function getVariantState(variant) {
      return window.AxiomVariantForm.getVariantState(variant, variantState);
    }

    function getVariantQuantityRule(variant) {
      return window.AxiomVariantForm.getQuantityRule(variant, variantState);
    }

    function shouldCheckVariantInventory(variant) {
      return window.AxiomVariantForm.shouldCheckInventory(variant, variantState);
    }

    function getVariantInventoryQuantity(variant) {
      return window.AxiomVariantForm.getInventoryQuantity(variant, variantState);
    }

    function isQuantityRuleSoldOut(variant) {
      return window.AxiomVariantForm.isSoldOut(variant, variantState);
    }

    function getEffectiveMaxQty(variant) {
      return window.AxiomVariantForm.getEffectiveMaxQty(variant, variantState);
    }

    function normalizeQty(rawValue, variant, allowZero) {
      return window.AxiomVariantForm.normalizeQty(rawValue, variant, variantState, allowZero);
    }

    function getDisplayPricing(variant, purchaseOptionState) {
      var allocation = purchaseOptionState && purchaseOptionState.allocation ? purchaseOptionState.allocation : null;
      return {
        price: allocation && allocation.price != null ? allocation.price : variant.price,
        compareAtPrice: allocation && allocation.compareAtPrice != null ? allocation.compareAtPrice : variant.compare_at_price
      };
    }

    function getAtcActiveLabel(button) {
      return button.dataset.addLabel || 'Add to cart';
    }

    function findVariantByOptions(options) {
      if (highVariantProduct) return selectedHighVariant;
      return window.AxiomVariantForm.findVariant(product, options);
    }

    function getSelectedVariant() {
      return findVariantByOptions(window.AxiomVariantForm.selectedOptions(root, '[data-featured-option-button]'));
    }

    function setFeaturedAtcLoading(isLoading) {
      if (!atcBtn) return;
      atcBtn.classList.toggle('loading', Boolean(isLoading));
    }

    function setDynamicCheckoutLoading(isLoading) {
      if (!dynamicCheckoutRoot) return;
      dynamicCheckoutRoot.classList.toggle('is-loading', Boolean(isLoading));
    }

    function isDynamicCheckoutActivation(event) {
      var path = event && typeof event.composedPath === 'function'
        ? event.composedPath()
        : [event && event.target];

      return path.some(function (node) {
        return node && node.nodeType === 1 && node.matches && node.matches(
          'shopify-accelerated-checkout, shopify-buy-it-now-button, .shopify-payment-button__button'
        );
      });
    }

    function getVariantForOptions(options) {
      return findVariantByOptions(options);
    }

    function clearAddedStateTimer() {
      if (addedResetTimer) {
        window.clearTimeout(addedResetTimer);
        addedResetTimer = null;
      }
    }

    function syncSelectedOptionsUI(variant) {
      var options = window.AxiomVariantForm.getVariantOptions(variant);
      if (!options.length) return;
      options.forEach(function (value, index) {
        var position = index + 1;
        root.querySelectorAll('[data-featured-option-button][data-option-position="' + position + '"]').forEach(function (item) {
          var isActive = item.dataset.value === value;
          item.classList.toggle('active', isActive);
          item.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });
        var selectedValueLabel = root.querySelector('[data-featured-option-value="' + position + '"], [data-option-selected-value="' + position + '"]');
        if (selectedValueLabel) selectedValueLabel.textContent = value;
      });
    }

    function syncOptionAvailabilityUI() {
      if (highVariantProduct) {
        window.AxiomHighVariantPicker.applyAvailability(root, '[data-featured-option-button]', highVariantState);
        return;
      }
      var selected = window.AxiomVariantForm.selectedOptions(root, '[data-featured-option-button]');
      root.querySelectorAll('[data-featured-option-button]').forEach(function (button) {
        var position = parseInt(button.dataset.optionPosition, 10);
        var candidateVariant = window.AxiomVariantForm.findAvailableVariantForOptionValue(
          product,
          selected,
          position,
          button.dataset.value,
          variantState
        );
        var isUnavailable = !candidateVariant;
        button.classList.toggle('unavailable', isUnavailable);
        button.dataset.resolvedOptionVariantId = candidateVariant ? String(candidateVariant.id) : '';
        button.dataset.optionValueAvailable = isUnavailable ? 'false' : 'true';
        button.removeAttribute('aria-disabled');
        var unavailableLabel = button.querySelector('[data-option-unavailable-label]');
        if (unavailableLabel) unavailableLabel.hidden = !isUnavailable;
        if (button.dataset.optionAccessibleLabel) {
          button.setAttribute('aria-label', button.dataset.optionAccessibleLabel + (isUnavailable && unavailableLabel ? unavailableLabel.textContent : ''));
        }
      });
    }

    function syncVariantImageSwatchesUI() {
      if (!window.AxiomVariantForm || typeof window.AxiomVariantForm.syncVariantImageSwatches !== 'function') return;
      window.AxiomVariantForm.syncVariantImageSwatches({
        root: root,
        buttonSelector: '[data-featured-option-button]',
        product: product,
        selected: window.AxiomVariantForm.selectedOptions(root, '[data-featured-option-button]'),
        contextualState: highVariantProduct ? highVariantState : null
      });
    }

    function resetAtcFeedback(variant) {
      clearAddedStateTimer();
      pendingVariantId = null;
      pendingSource = '';
      if (!atcBtn) return;
      atcBtn.classList.remove('loading', 'added');
      if (!atcLabel) return;
      if (!variant) {
        setMotionButtonText(atcLabel, atcBtn.dataset.unavailableLabel || config.unavailable || 'Unavailable');
        return;
      }
      setMotionButtonText(atcLabel, (variant.available && !isQuantityRuleSoldOut(variant))
        ? getAtcActiveLabel(atcBtn)
        : (atcBtn.dataset.soldOutLabel || 'Sold out'));
    }

    function setUnavailableSelectionUI() {
      setVariantLoading(false);
      if (variantIdInput) variantIdInput.value = '';
      resetAtcFeedback(null);
      setCartStatus('');
      if (atcBtn) atcBtn.disabled = true;
      if (qtyInput) qtyInput.value = '0';
      if (qtyVal) qtyVal.textContent = '0';
      if (qtyMinusBtn) qtyMinusBtn.disabled = true;
      if (qtyPlusBtn) qtyPlusBtn.disabled = true;

      if (dynamicCheckoutRoot) {
        dynamicCheckoutRoot.classList.add('dynamic-checkout--disabled');
        dynamicCheckoutRoot.classList.remove('is-loading');
        dynamicCheckoutRoot.dataset.soldOut = 'true';
      }
    }

    function updateInventoryStatusUI(variant, soldOutByRule) {
      var inventoryStatus = root.querySelector('[data-featured-inventory-status]');
      if (!inventoryStatus || !variant) return;
      var inventoryQty = Math.max(0, getVariantInventoryQuantity(variant));
      var threshold = Math.max(1, parseInt(inventoryStatus.dataset.lowStockThreshold, 10) || 15);
      var showLowStock = config.manualPreorder !== true
        && variant.available
        && !soldOutByRule
        && shouldCheckVariantInventory(variant)
        && inventoryQty > 0
        && inventoryQty <= threshold;
      inventoryStatus.hidden = !showLowStock;
      if (showLowStock) {
        if (window.AxiomInventoryMessage) window.AxiomInventoryMessage.update(inventoryStatus, inventoryQty);
      }
    }

    function updateDynamicCheckoutUI(variant, soldOutByRule, purchaseOptionState) {
      if (!dynamicCheckoutRoot || !variant) return;
      var max = getEffectiveMaxQty(variant);
      var isDisabled = !variant.available || soldOutByRule || (max !== null && max < window.AxiomVariantForm.getMinimumAddQty(variant, variantState));
      dynamicCheckoutRoot.classList.toggle('dynamic-checkout--disabled', isDisabled);
      dynamicCheckoutRoot.classList.toggle('is-loading', false);
      dynamicCheckoutRoot.dataset.soldOut = isDisabled ? 'true' : 'false';
    }

    function updateMedia(variant, options) {
      if (!variant) return;
      if (galleryController && typeof galleryController.setVariantMedia === 'function') {
        galleryController.setVariantMedia(variant);
      }
      var mediaId = variant.featured_media && variant.featured_media.id
        ? variant.featured_media.id
        : (variant.featured_image && variant.featured_image.id ? variant.featured_image.id : null);
      if (mediaId) setActiveMediaById(mediaId, options);
    }

    function syncQtyControls(variant, keepCurrentValue) {
      window.AxiomVariantForm.syncQuantityControls({
        root: root,
        variant: variant,
        state: variantState,
        inputSelector: '[data-featured-qty-input]',
        valueSelector: '[data-featured-qty-val]',
        minusSelector: '[data-featured-qty-minus]',
        plusSelector: '[data-featured-qty-plus]',
        keepCurrentValue: keepCurrentValue
      });

      var qtyPricing = root.querySelector('[data-featured-quantity-pricing-current]');
      if (qtyPricing) {
        var purchaseOptionState = null;
        var displayPricing = getDisplayPricing(variant, purchaseOptionState);
        qtyPricing.textContent = String(config.quantityPriceAtEach || '').replace('[price]', money(displayPricing.price));
      }
    }

    function updateVariantUI(variant, options) {
      setVariantLoading(false);
      if (!variant) {
        if (window.AxiomProductBadges) {
          window.AxiomProductBadges.update(root, { productId: product && product.id, available: false, price: 0, compareAtPrice: 0, purchaseOptionLabel: '' });
        }
        setUnavailableSelectionUI();
        syncOptionAvailabilityUI();
        syncVariantImageSwatchesUI();
        if (window.AxiomStandardStorefront && typeof window.AxiomStandardStorefront.dispatchProductSelect === 'function') {
          window.AxiomStandardStorefront.dispatchProductSelect(root, product, null);
        }
        return;
      }
      syncSelectedOptionsUI(variant);
      var soldOutByRule = isQuantityRuleSoldOut(variant);
      var purchaseOptionState = null;
      var displayPricing = getDisplayPricing(variant, purchaseOptionState);
      if (window.AxiomProductBadges) {
        window.AxiomProductBadges.update(root, {
          productId: product && product.id,
          available: variant.available,
          price: variant.price,
          compareAtPrice: variant.compare_at_price,
          purchaseOptionLabel: purchaseOptionState && purchaseOptionState.purchaseOptionLabel,
        });
      }
      var maxAddQuantity = getEffectiveMaxQty(variant);
      var cartLimitReached = variant.available && !soldOutByRule && maxAddQuantity !== null
        && maxAddQuantity < window.AxiomVariantForm.getMinimumAddQty(variant, variantState);
      var isPurchasable = variant.available && !soldOutByRule && !cartLimitReached;
      var priceEl = root.querySelector('[data-featured-price]');
      var priceBlock = root.querySelector('[data-featured-price-block]');
      var compareEl = root.querySelector('[data-featured-compare-price]');
      var saveEl = root.querySelector('[data-featured-save-badge]');
      var unitPriceEl = root.querySelector('[data-featured-unit-price]');
      var skuEl = root.querySelector('[data-featured-sku]');
      if (priceBlock) priceBlock.toggleAttribute('data-on-sale', Boolean(displayPricing.compareAtPrice && displayPricing.compareAtPrice > displayPricing.price));

      if (variantIdInput) variantIdInput.value = variant.id;
      if (priceEl) {
        priceEl.textContent = money(displayPricing.price);
        priceEl.setAttribute('aria-label', (displayPricing.compareAtPrice && displayPricing.compareAtPrice > displayPricing.price ? priceBlock && priceBlock.dataset.salePriceLabel : priceBlock && priceBlock.dataset.regularPriceLabel) + ': ' + money(displayPricing.price));
      }
      var atcPriceCurrent = root.querySelector('[data-atc-price-current]');
      var atcPriceCompare = root.querySelector('[data-atc-price-compare]');
      if (atcPriceCurrent) atcPriceCurrent.textContent = money(displayPricing.price);
      if (atcPriceCompare) {
        if (displayPricing.compareAtPrice && displayPricing.compareAtPrice > displayPricing.price) {
          atcPriceCompare.hidden = false;
          atcPriceCompare.textContent = money(displayPricing.compareAtPrice);
        } else {
          atcPriceCompare.hidden = true;
          atcPriceCompare.textContent = '';
        }
      }
      if (compareEl) {
        if (displayPricing.compareAtPrice && displayPricing.compareAtPrice > displayPricing.price) {
          compareEl.hidden = false;
          compareEl.textContent = money(displayPricing.compareAtPrice);
          compareEl.setAttribute('aria-label', (priceBlock && priceBlock.dataset.regularPriceLabel) + ': ' + money(displayPricing.compareAtPrice));
        } else {
          compareEl.hidden = true;
          compareEl.textContent = '';
          compareEl.removeAttribute('aria-label');
        }
      }
      if (saveEl) {
        if (displayPricing.compareAtPrice && displayPricing.compareAtPrice > displayPricing.price) {
          saveEl.hidden = false;
          saveEl.textContent = formatSaveLabel(
            displayPricing.compareAtPrice,
            displayPricing.price,
            config.savingLabel || 'Save [amount]',
            config.savingMode || 'amount'
          );
        } else {
          saveEl.hidden = true;
          saveEl.textContent = '';
        }
      }
      if (unitPriceEl) {
        if (variant.unit_price && variant.unit_price_measurement) {
          var measurement = variant.unit_price_measurement;
          var referenceValue = measurement.reference_value && measurement.reference_value !== 1 ? measurement.reference_value : '';
          unitPriceEl.textContent = money(variant.unit_price) + ' / ' + referenceValue + measurement.reference_unit;
          unitPriceEl.setAttribute('aria-label', (priceBlock && priceBlock.dataset.unitPriceLabel) + ': ' + unitPriceEl.textContent);
          unitPriceEl.hidden = false;
        } else {
          unitPriceEl.textContent = '';
          unitPriceEl.removeAttribute('aria-label');
          unitPriceEl.hidden = true;
        }
      }
      if (skuEl) skuEl.textContent = variant.sku || '';
      if (atcBtn) {
        atcBtn.disabled = !isPurchasable;
      }
      if (window.AxiomAddToCartAnimation && atcBtn) {
        window.AxiomAddToCartAnimation.setImage(
          atcBtn,
          window.AxiomAddToCartAnimation.imageForVariant(variant, atcBtn.dataset.atcAnimationFallback)
        );
      }
      resetAtcFeedback(variant);
      setCartStatus(cartLimitReached ? productString('maximumQuantityInBag') : '');
      updateInventoryStatusUI(variant, soldOutByRule);
      updateDynamicCheckoutUI(variant, soldOutByRule, purchaseOptionState);
      syncQtyControls(variant, true);
      syncOptionAvailabilityUI();
      syncVariantImageSwatchesUI();
      updateMedia(variant, options || {});
      if (window.AxiomStandardStorefront && typeof window.AxiomStandardStorefront.dispatchProductSelect === 'function') {
        window.AxiomStandardStorefront.dispatchProductSelect(root, product, variant);
      }
      if (window.AxiomSellingPlan) window.AxiomSellingPlan.syncWithin(root, variant.id);
    }

    root.querySelectorAll('[data-featured-option-button]').forEach(function (button) {
      button.addEventListener('click', function () {
        var position = parseInt(button.dataset.optionPosition, 10);
        if (!position) return;

        root.querySelectorAll('[data-featured-option-button][data-option-position="' + position + '"]').forEach(function (item) {
          var isActive = item === button;
          item.classList.toggle('active', isActive);
          item.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });

        var selectedValueLabel = root.querySelector('[data-featured-option-value="' + position + '"], [data-option-selected-value="' + position + '"]');
        if (selectedValueLabel) selectedValueLabel.textContent = button.dataset.value;

        var shouldScrollMedia = button.hasAttribute('data-variant-media-scroll');
        if (highVariantProduct) {
          if (highVariantRequest) highVariantRequest.abort();
          highVariantRequest = new AbortController();
          var request = highVariantRequest;
          selectedHighVariant = null;
          setVariantLoading(true);
          if (window.AxiomVariantForm && typeof window.AxiomVariantForm.setVariantImageSwatchesLoading === 'function') {
            window.AxiomVariantForm.setVariantImageSwatchesLoading({
              root: root,
              buttonSelector: '[data-featured-option-button]'
            }, true);
          }
          if (variantIdInput) variantIdInput.value = '';
          if (atcBtn) atcBtn.disabled = true;
          if (dynamicCheckoutRoot) dynamicCheckoutRoot.classList.add('dynamic-checkout--disabled');
          window.AxiomHighVariantPicker.request(
            highVariantState.productUrl,
            window.AxiomHighVariantPicker.selectedOptionValueIds(root, '[data-featured-option-button]'),
            request.signal
          ).then(function (state) {
            if (request !== highVariantRequest) return;
            highVariantRequest = null;
            highVariantState = state;
            selectedHighVariant = state.variant;
            if (state.variant && state.variantState) {
              variantState[String(state.variant.id)] = state.variantState;
            }
            updateVariantUI(state.variant, {
              scrollMedia: shouldScrollMedia,
              scrollThumb: shouldScrollMedia,
              source: 'variant'
            });
          }).catch(function (error) {
            if (error.name === 'AbortError' || request !== highVariantRequest) return;
            highVariantRequest = null;
            if (window.AxiomVariantForm && typeof window.AxiomVariantForm.setVariantImageSwatchesLoading === 'function') {
              window.AxiomVariantForm.setVariantImageSwatchesLoading({
                root: root,
                buttonSelector: '[data-featured-option-button]'
              }, false);
            }
            setUnavailableSelectionUI();
            setCartStatus(error.message || config.unavailable);
          });
          return;
        }
        updateVariantUI(getSelectedVariant(), {
          scrollMedia: shouldScrollMedia,
          scrollThumb: shouldScrollMedia,
          source: 'variant'
        });
      });
    });

    root.querySelectorAll('[data-thumb-nav-prev], [data-media-prev]').forEach(function (button) {
      on(button, 'click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        if (galleryController) setActiveMedia(galleryController.currentIdx - 1, { scrollMedia: true, source: 'previous' });
      });
    });
    root.querySelectorAll('[data-thumb-nav-next], [data-media-next]').forEach(function (button) {
      on(button, 'click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        if (galleryController) setActiveMedia(galleryController.currentIdx + 1, { scrollMedia: true, source: 'next' });
      });
    });
    function syncSplitRowControls(row) {
      var track = row && row.querySelector('[data-split-showcase-track]');
      if (!track) return;
      var maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
      var previous = row.querySelector('[data-split-row-prev]');
      var next = row.querySelector('[data-split-row-next]');
      if (previous) previous.disabled = track.scrollLeft <= 1;
      if (next) next.disabled = track.scrollLeft >= maxScroll - 1;
    }

    root.querySelectorAll('[data-split-showcase-row]').forEach(function (row) {
      var track = row.querySelector('[data-split-showcase-track]');
      if (track) on(track, 'scroll', function () { syncSplitRowControls(row); }, { passive: true });
      syncSplitRowControls(row);
    });
    on(window, 'resize', function () {
      root.querySelectorAll('[data-split-showcase-row]').forEach(syncSplitRowControls);
    }, { passive: true });

    root.querySelectorAll('[data-split-row-prev], [data-split-row-next]').forEach(function (button) {
      on(button, 'click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        var row = button.closest('[data-split-showcase-row]');
        var track = row && row.querySelector('[data-split-showcase-track]');
        if (!track) return;
        var direction = button.hasAttribute('data-split-row-prev') ? -1 : 1;
        track.scrollBy({ left: direction * track.clientWidth, behavior: 'smooth' });
      });
    });

    on(root, 'featured-product:set-media', function (event) {
      if (!event || !event.detail) return;
      if (typeof event.detail.index === 'number') {
        setActiveMedia(event.detail.index, { scrollMedia: true, source: 'external' });
        return;
      }
      if (event.detail.mediaId) {
        setActiveMediaById(event.detail.mediaId, { scrollMedia: true, scrollThumb: true, source: 'external' });
      }
    });

    function getActiveVariantForQty() {
      var selectedVariant = getSelectedVariant();
      if (selectedVariant) return selectedVariant;
      if (!variantIdInput || !variantIdInput.value || !product || !product.variants) return null;
      return product.variants.find(function (variant) {
        return String(variant.id) === String(variantIdInput.value);
      }) || null;
    }

    if (qtyMinusBtn) {
      qtyMinusBtn.addEventListener('click', function () {
        var activeVariant = getActiveVariantForQty();
        if (!activeVariant || !qtyInput) return;
        var quantityRule = getVariantQuantityRule(activeVariant);
        var currentQty = parseInt(qtyInput.value || quantityRule.min, 10) || quantityRule.min;
        qtyInput.value = normalizeQty(currentQty - quantityRule.increment, activeVariant, false);
        syncQtyControls(activeVariant, true);
      });
    }

    if (qtyPlusBtn) {
      qtyPlusBtn.addEventListener('click', function () {
        var activeVariant = getActiveVariantForQty();
        if (!activeVariant || !qtyInput) return;
        var quantityRule = getVariantQuantityRule(activeVariant);
        var currentQty = parseInt(qtyInput.value || quantityRule.min, 10) || quantityRule.min;
        qtyInput.value = normalizeQty(currentQty + quantityRule.increment, activeVariant, false);
        syncQtyControls(activeVariant, true);
      });
    }

    if (qtyInput) {
      qtyInput.addEventListener('change', function () {
        var activeVariant = getActiveVariantForQty();
        if (!activeVariant) return;
        qtyInput.value = normalizeQty(qtyInput.value, activeVariant, false);
        syncQtyControls(activeVariant, true);
      });
    }

    if (form) {
      form.addEventListener('submit', function (event) {
        var submitter = getFormSubmitter(event);
        if (!submitter || !submitter.matches('[data-featured-atc]')) {
          if (window.AxiomVariantForm && typeof window.AxiomVariantForm.formHasFiles === 'function' && window.AxiomVariantForm.formHasFiles(form)) {
            event.preventDefault();
            event.stopImmediatePropagation();
            setDynamicCheckoutLoading(true);
            window.AxiomStandardStorefront.addProductForm(form, {
              target: form,
              source: sourceToken || 'featured-product',
              redirectToCheckout: true
            }).catch(function (error) {
              setDynamicCheckoutLoading(false);
              setCartStatus(error && error.message || cartString('addError'));
            });
            return;
          }
          var checkoutVariant = getActiveVariantForQty() || getSelectedVariant();
          var checkoutPlanValidation = window.AxiomSellingPlan && checkoutVariant
            ? window.AxiomSellingPlan.validateVariant(form, getVariantState(checkoutVariant))
            : { valid: true };
          if (!checkoutPlanValidation.valid) {
            event.preventDefault();
            event.stopImmediatePropagation();
            if (!checkoutPlanValidation.displayed) setCartStatus(checkoutPlanValidation.message);
            return;
          }
          if (dynamicCheckoutRoot && dynamicCheckoutRoot.classList.contains('dynamic-checkout--disabled')) {
            event.preventDefault();
            event.stopImmediatePropagation();
            return;
          }
          setDynamicCheckoutLoading(true);
          return;
        }
        event.preventDefault();
        var activeVariant = getSelectedVariant();
        if (!activeVariant) {
          setUnavailableSelectionUI();
          syncOptionAvailabilityUI();
          return;
        }
        if (variantIdInput) variantIdInput.value = activeVariant.id;
        if (!variantIdInput || !variantIdInput.value) return;
        updateVariantUI(activeVariant);
        if (atcBtn && atcBtn.disabled) return;
        var planValidation = window.AxiomSellingPlan
          ? window.AxiomSellingPlan.validateVariant(form, getVariantState(activeVariant))
          : { valid: true };
        if (!planValidation.valid) {
          if (!planValidation.displayed) setCartStatus(planValidation.message);
          return;
        }
        setCartStatus('');
        resetAtcFeedback(activeVariant);
        if (window.AxiomAddToCartAnimation) {
          window.AxiomAddToCartAnimation.play({
            button: atcBtn,
            imageUrl: window.AxiomAddToCartAnimation.imageForVariant(activeVariant, atcBtn && atcBtn.dataset.atcAnimationFallback),
            mode: 'main'
          });
        }
        setFeaturedAtcLoading(true);

        var customOptionValidation = window.AxiomCustomOptions && typeof window.AxiomCustomOptions.validate === 'function'
          ? window.AxiomCustomOptions.validate(form)
          : { valid: true };
        if (!customOptionValidation.valid) {
          setCartStatus(customOptionValidation.message);
          setFeaturedAtcLoading(false);
          return;
        }

        var addRequest = window.AxiomVariantForm && typeof window.AxiomVariantForm.formHasFiles === 'function' && window.AxiomVariantForm.formHasFiles(form)
          ? window.AxiomStandardStorefront.addProductForm(form, { target: form, source: sourceToken || 'featured-product' })
          : window.AxiomStandardStorefront.addLines({
              id: parseInt(activeVariant.id, 10),
              quantity: qtyInput ? parseInt(qtyInput.value || '1', 10) : 1,
              properties: window.AxiomVariantForm.collectProperties(form),
              sellingPlanId: sellingPlanIdFromForm(form)
            }, {
              target: form,
              source: sourceToken || 'featured-product'
            });

        addRequest.then(function (result) {
          window.AxiomVariantForm.syncCartQuantity(activeVariant, variantState, result && result.cart);
          updateVariantUI(activeVariant);
          pendingVariantId = null;
          pendingSource = '';
          if (!atcBtn || !atcLabel) return;
          atcBtn.classList.remove('loading');
          if (window.AxiomAddToCartAnimation && window.AxiomAddToCartAnimation.isEnabled()) {
            atcBtn.classList.remove('added');
            setMotionButtonText(atcLabel, getAtcActiveLabel(atcBtn));
            clearAddedStateTimer();
            return;
          }
          atcBtn.classList.add('added');
          setMotionButtonText(atcLabel, atcBtn.dataset.addedLabel || 'Added');
          clearAddedStateTimer();
          addedResetTimer = window.setTimeout(function () {
            atcBtn.classList.remove('added');
            var activeVariantForReset = getActiveVariantForQty();
            if (!activeVariantForReset) return;
            setMotionButtonText(atcLabel, (activeVariantForReset.available && !isQuantityRuleSoldOut(activeVariantForReset))
              ? getAtcActiveLabel(atcBtn)
              : (atcBtn.dataset.soldOutLabel || 'Sold out'));
          }, 2000);
        }).catch(function (error) {
          setCartStatus(error && error.message || cartString('addError'));
          var activeVariantForError = getActiveVariantForQty();
          resetAtcFeedback(activeVariantForError);
        });
        pendingVariantId = String(activeVariant.id);
        pendingSource = sourceToken;
      });
    }
    if (dynamicCheckoutRoot) {
      on(dynamicCheckoutRoot, 'click', function (event) {
        if (!isDynamicCheckoutActivation(event)) return;

        if (window.AxiomVariantForm && typeof window.AxiomVariantForm.formHasFiles === 'function' && window.AxiomVariantForm.formHasFiles(form)) {
          event.preventDefault();
          event.stopImmediatePropagation();
          var fileCheckoutValidation = window.AxiomCustomOptions && typeof window.AxiomCustomOptions.validate === 'function'
            ? window.AxiomCustomOptions.validate(form)
            : { valid: true };
          if (!fileCheckoutValidation.valid) {
            setCartStatus(fileCheckoutValidation.message);
            return;
          }
          setDynamicCheckoutLoading(true);
          window.AxiomStandardStorefront.addProductForm(form, {
            target: form,
            source: sourceToken || 'featured-product',
            redirectToCheckout: true
          }).catch(function (error) {
            setDynamicCheckoutLoading(false);
            setCartStatus(error && error.message || cartString('addError'));
          });
          return;
        }

        if (dynamicCheckoutRoot.classList.contains('dynamic-checkout--disabled')) {
          event.preventDefault();
          event.stopImmediatePropagation();
          var activeVariant = getActiveVariantForQty() || getSelectedVariant();
          return;
        }
        setDynamicCheckoutLoading(true);
      }, true);
      on(window, 'pageshow', function () {
        setDynamicCheckoutLoading(false);
      });
    }

    on(document, 'shopify:cart:error', function () {
      if (!pendingVariantId) return;
      var activeVariant = getActiveVariantForQty();
      resetAtcFeedback(activeVariant);
    });

    var initialVariant = highVariantProduct ? selectedHighVariant : (getSelectedVariant() || product.selected_or_first_available_variant || null);
    if (initialVariant) {
      updateVariantUI(initialVariant);
    }

    if (window.Axiom && typeof window.Axiom.requestMotionRefresh === 'function') {
      window.Axiom.requestMotionRefresh(root);
    }

    root.__featuredProductCleanup = function () {
      if (highVariantRequest) highVariantRequest.abort();
      pauseProductMedia();
      clearAddedStateTimer();
      pendingVariantId = null;
      pendingSource = '';
      if (galleryController && typeof galleryController.dispose === 'function') {
        galleryController.dispose();
        galleryController = null;
      }
      cleanups.forEach(function (cleanup) {
        cleanup();
      });
      cleanups = [];
      root.dataset.featuredProductInitialized = 'false';
    };
  }

  function initAllFeaturedProducts(scope) {
    var root = scope && scope.querySelector ? scope : document;
    root.querySelectorAll('[data-featured-product-root]').forEach(initFeaturedProduct);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAllFeaturedProducts(document);
    });
  } else {
    initAllFeaturedProducts(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAllFeaturedProducts(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    if (!event.target || !event.target.querySelectorAll) return;
    event.target.querySelectorAll('[data-featured-product-root]').forEach(function (root) {
      if (typeof root.__featuredProductCleanup === 'function') {
        root.__featuredProductCleanup();
        root.__featuredProductCleanup = null;
      }
    });
  });
})();
